export default t => [
  {
    id: 20000,
    title: t('c.l.sidebar.20000.title', 'SERVICES'),
    items: [
      {
        id: 21000,
        title: t('c.l.sidebar.21000.title', 'Home'),
        link: '/partner',
        icon: 'la la-home',
      },
      {
        id: 22000,
        title: t('c.l.sidebar.22000.title', 'Dashboard'),
        link: '/partner/dashboard',
        icon: 'la la-bar-chart',
      },
      {
        id: 23000,
        title: t('c.l.sidebar.23000.title', 'Finance'),
        link: '/partner/finance',
        icon: 'la la-credit-card',
        sublinks: ['/partner/finance/detail'],
      },
      /*{
        id: 24000,
        title: t('c.l.sidebar.24000.title', 'Link Builder'),
        link: '/partner/link-builder',
        icon: 'la la-diamond',
      },*/
    ],
  },
  {
    id: 30000,
    title: t('c.l.sidebar.30000.title', 'SYSTEM'),
    items: [
      {
        id: 31000,
        title: t('c.l.sidebar.31000.title', 'Settings'),
        link: '/partner/settings',
        icon: 'la la-cog',
        sublinks: ['/partner/settings/edit-account'],
      },
    ],
  },
];
